import React from "react"

import Container from "../../../common/container/container"
import AdventuresItem from "./norwayItem"
import { useStaticQuery, graphql } from "gatsby"

import "./norway.css"
const test = () => {
  console.log("test")
}
const Adventures = ({ test, filterList }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            norwayItems {
              item {
                status {
                  category
                  date
                  season
                }
                title
                location
                userName
                description1
                dates
                show {
                  regular_price
                  promotional_price
                }
                rating {
                  stars
                  review
                  adventures
                }
                mainImage
                guideImage
                link
              }
            }
          }
        }
      }
    `
  )
  let filterArray =
    site.siteMetadata &&
    site.siteMetadata.norwayItems.map(items => items.item.status.season)
  let uniqueArray = filterArray.filter(function(item, pos) {
    return filterArray.indexOf(item) == pos
  })

  return (
    <div className="adventures ladakh">
      <div className="filters">
        {uniqueArray
          ? uniqueArray.map((items, i) => {
              return (
                <span key={i} onClick={() => test(site.siteMetadata, items)}>
                  {items}
                </span>
              )
            })
          : null}
      </div>
      <Container>
        <div className="row" id="test">
          {filterList.length > 0
            ? filterList.map((items, i) => {
                return (
                  <AdventuresItem
                    key={i}
                    mainImage={items.item.mainImage}
                    itemInfo={items}
                  />
                )
              })
            : site.siteMetadata && site.siteMetadata.norwayItems
            ? site.siteMetadata.norwayItems.map((items, i) => {
                return (
                  <AdventuresItem
                    key={i}
                    mainImage={items.item.mainImage}
                    itemInfo={items}
                  />
                )
              })
            : null}
        </div>
      </Container>
    </div>
  )
}

export default Adventures
